import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate, Link } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { MdOutlineMailOutline } from "react-icons/md";
import { Form, Input, Button, notification } from "antd";
import axios from "axios";
import { useUser } from "../../context/UserContext";
import { useGoogleLogin } from "@react-oauth/google";
import { ClipLoader } from "react-spinners";
import { FaSpinner } from "react-icons/fa";


export const addCredentialsSSO = async (credentialDetails) => {

  const signUpApiUrl = process.env.REACT_APP_SIGNUP_API;
  const signInApiUrl = process.env.REACT_APP_SIGNIN_API;

  try {
    const response = await axios.post(signUpApiUrl, credentialDetails, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response) {
      const responseData = await response.data;

      if (responseData.status === 201) {
        localStorage.setItem("accessToken", responseData.data.accessToken);
        localStorage.setItem("refreshToken", responseData.data.refreshToken);
        localStorage.setItem("clientId", responseData.data.clientId);
      }
      else if (responseData.status === 409) {
        const signInresponse = await axios.post(
          signInApiUrl,
          credentialDetails,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (signInresponse) {
          const signInData = await signInresponse.data;
          if (signInData.status === 200) {
            localStorage.setItem("accessToken", signInData.data.accessToken);
            localStorage.setItem("refreshToken", signInData.data.refreshToken);
            localStorage.setItem("clientId", signInData.data.clientId);
          }
          return signInData;
        }
      }
      return responseData;
    } else {
      console.error("Error from API:", response.error);
    }
  } catch (error) {
    console.error("Error during API call:", error);
  }
};

export const SSOSignin = ({ isAuthenticated, setIsAuthenticated }) => {
  const { setUser } = useUser();

  const { instance } = useMsal();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const Loader = <TailSpin visible={true} height="30" width="50" radius="1" />;

  const activateLoader = () => {
    setIsLoading(true);
  };

  const deactivateLoader = () => {
    setIsLoading(false);
  };
  const [api, contextHolder] = notification.useNotification();
  const signInNotification = (type, text) => {
    api[type]({
      message: text,
    });
  };

  const handleSignInWithMicrosoft = async () => {
    try {
      instance.loginRedirect({
        scopes: ["user.read"],
      });
    } catch (err) {
      signInNotification("error", "Microsoft sign-in failed");
      deactivateLoader();
      console.error('Microsoft sign-in error', err);
    }
  };

  // const handleGoogleLogin = useGoogleLogin({
  //   onSuccess: async (tokenResponse) => {

  //     activateLoader();

  //     const { access_token } = tokenResponse;
  //     const userDetails = await fetchUserDetails(access_token);


  //     if (userDetails.email_verified) {

  //       setIsAuthenticated(true);

  //       setUser({
  //         name: userDetails.name,
  //         email: userDetails.email,
  //         signInType: "googlesso",
  //       });

  //       await addCredentialsSSO({
  //         name: userDetails.name,
  //         email: userDetails.email,
  //         password: userDetails.sub,
  //         type: "googlesso",
  //         verificationCode: null,
  //       });

  //       localStorage.setItem(
  //         "GoogleSignIn",
  //         JSON.stringify({
  //           isAuthenticated: true,
  //           name: userDetails.name,
  //           email: userDetails.email,
  //           signInType: "Google",
  //         })
  //       );

  //       navigate("/dashboard");
  //       deactivateLoader();
  //     }
  //   },
  //   onError: (error) => {
  //     console.log("Login Failed:", error);
  //     deactivateLoader();
  //   },
  // });

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (credentialResponse) => {
      try {
        const userToken = credentialResponse.access_token;
        const userInfoResponse = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${userToken}` },
        });

        const userInfo = await userInfoResponse.json();
        activateLoader();
        if (userInfo.email_verified) {
          setIsAuthenticated(true);

          setUser({
            name: userInfo.name,
            email: userInfo.email,
            signInType: "googlesso",
          });

          await addCredentialsSSO({
            name: userInfo.name,
            email: userInfo.email,
            password: userInfo.sub,
            type: "googlesso",
            verificationCode: null,
          });

          localStorage.setItem(
            "GoogleSignIn",
            JSON.stringify({
              isAuthenticated: true,
              name: userInfo.name,
              email: userInfo.email,
              signInType: "Google",
            })
          );

          navigate("/dashboard");
          deactivateLoader();
        } else {
          console.error("Google Sign-in Failed. Email not verified.");
        }
      } catch (err) {
        console.log("error", err);
        deactivateLoader();
        signInNotification("error", "Google sign-in failed");
      }
    },
    onError: () => {
      console.log("Google Sign-in Failed. Try again.");
      setUser({});
      deactivateLoader();
    }
  });

  const fetchUserDetails = async (token) => {
    const response = await fetch(
      `https://www.googleapis.com/oauth2/v3/userinfo`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  };

  useEffect(() => {
    if (isAuthenticated) {
      const activeAccount = instance?.getActiveAccount();
      if (activeAccount) {
        const accountId = activeAccount.localAccountId;
        navigate("/dashboard");
      }
    }
  }, [isAuthenticated]);

  const handleFormSubmit = async (formData) => {
    activateLoader();

    const signInApiUrl = process.env.REACT_APP_SIGNIN_API;

    if (!formData.email || !formData.password) {
      signInNotification("error", "Provide All Details");
      deactivateLoader();
    }

    const credentialDetails = {
      email: formData.email,
      password: formData.password,
      type: "basicauth",
      token: "",
    };

    try {
      const signInresponse = await axios.post(signInApiUrl, credentialDetails, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (signInresponse) {
        const responseData = await signInresponse.data;

        if (responseData.status === 200) {

          setIsAuthenticated(true);
          setUser({
            name: responseData.data.name,
            email: formData.email,
            signInType: "basicauth",
          });

          localStorage.setItem(
            "BasicAuth",
            JSON.stringify({
              isAuthenticated: true,
              name: responseData.data.name,
              email: formData.email,
              signInType: "BasicAuth",
            })
          );
          localStorage.setItem("accessToken", responseData.data.accessToken);
          localStorage.setItem("refreshToken", responseData.data.refreshToken);
          localStorage.setItem("clientId", responseData.data.clientId);

          navigate("/dashboard");
          deactivateLoader();
        }
        else if (responseData.message === 'Invalid Password') {
          signInNotification("error", "Invalid Password");
        }
        else {
          signInNotification("error", "Sign-in failed");
        }
        return responseData;
      } else {
        console.error("Error from API:", signInresponse.error);
        signInNotification("error", "Sign-in failed");
        deactivateLoader();
      }
    } catch (error) {
      console.error("Error during API call:", error);
      signInNotification("error", "Sign-in failed");
      deactivateLoader();
    } finally {
      deactivateLoader();
    }
  };
  useEffect(() => { console.log('loading', isLoading) }, [isLoading])
  return (
    <>
      {contextHolder}
      <div className="h-screen grid grid-cols-1 md:grid-cols-1">
        <div className="signin_section flex flex-col justify-center items-center p-6 bg-blue-50">
          <div className="w-full max-w-sm bg-white rounded-lg shadow-lg px-8 py-10">
            <button
              className="w-full flex items-center gap-2 justify-center bg-[#11285b] text-white font-medium py-3 rounded-md mb-4 hover:bg-[#172e6c]"
              onClick={() => handleGoogleLogin()}
            >
              <img
                src="/images/google.png"
                alt="Google Logo"
                className="w-[1.5rem]"
              />
              <span className="text-[14px]">Sign in with Google</span>
            </button>
            <button
              className="w-full flex items-center gap-2 justify-center bg-[#11285b] text-white font-medium py-3 rounded-md hover:bg-[#172e6c]"
              onClick={() => { handleSignInWithMicrosoft(); }}
            >
              <img
                src="/images/microsoft-logo.png"
                alt="Microsoft Logo"
                className="w-[1rem]"
              />
              <span className="text-[14px]">Sign in with Microsoft</span>
            </button>

            <div className="flex items-center my-4">
              <hr className="flex-grow border-t border-gray-300" />
              <span className="mx-2 text-gray-500">or</span>
              <hr className="flex-grow border-t border-gray-300" />
            </div>

            <Form
              layout="vertical"
              onFinish={handleFormSubmit}
              requiredMark="optional"
            >
              <Form.Item
                label="Work email *"
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input className="h-10" placeholder="Enter your work email" />
              </Form.Item>
              <Form.Item
                label="Password *"
                name="password"
                rules={[
                  { required: true, message: "Please enter your password" },
                ]}
              >
                <Input className="h-10" placeholder="Enter your password" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn w-full flex items-center gap-2 justify-center bg-[#11285b] text-white font-medium py-3 h-[45px] rounded-md hover:bg-[#172e6c]"
                >
                  <MdOutlineMailOutline className="text-[18px]" /> Sign in with
                  Email
                </Button>
              </Form.Item>
            </Form>

            <p className="mt-4 text-sm text-center text-gray-600">
              Don't have an account?{" "}
              <Link to="/signup" className="text-blue-600 hover:underline">
                Sign Up
              </Link>
            </p>
          </div>
        </div>

        {/* {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.295)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000,
            }}
          >
            <ClipLoader color="#36d7b7" size={50} />
          </div>
        )} */}
        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0, 0, 0, 0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              backdropFilter: "blur(4px)",
            }}
          >
            <div
              style={{
                background: "#ffffff",
                padding: "32px 40px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
                minWidth: "240px",
              }}
            >
              <FaSpinner className="animate-spin" style={{ fontSize: "32px", color: "#1a73e8" }} />
              <span style={{ color: "#1a1a1a", fontSize: "16px", fontWeight: 500 }}>Signing you in...</span>
            </div>
          </div>
        )}

      </div>
    </>
  );
};
